/**
 * Room Service
 * 
 * Service for managing room-related API calls (create, join, fetch participants)
 */

import { appConfig } from '../config';

export interface CreateRoomResponse {
  success: boolean;
  joinCode?: string;
  roomId?: string;
  participantId?: string;
  // isHost?: boolean;
  error?: string;
}

export interface JoinRoomResponse {
  success: boolean;
  roomId?: string;
  participantId?: string;
  // isHost?: boolean;
  error?: string;
}

// export interface FetchParticipantsResponse {
//   success: boolean;
//   error?: string;
// }

export class RoomService {
  /**
   * Create a new room
   */
  async createRoom(playerName: string): Promise<CreateRoomResponse> {
    try {
      const response = await fetch(`${appConfig.serverUrl}/api/rooms/create`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ playerName }),
      });

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error creating room:', error);
      return {
        success: false,
        error: 'Failed to connect to server. Please try again.',
      };
    }
  }

  /**
   * Join an existing room
   */
  async joinRoom(joinCode: string, playerName: string): Promise<JoinRoomResponse> {
    try {
      const response = await fetch(`${appConfig.serverUrl}/api/rooms/join`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          joinCode: joinCode.trim().toUpperCase(),
          playerName,
        }),
      });

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error joining room:', error);
      return {
        success: false,
        error: 'Failed to connect to server. Please try again.',
      };
    }
  }

  // /**
  //  * Fetch participants for a room
  //  */
  // async fetchParticipants(roomId: string): Promise<FetchParticipantsResponse> {
  //   try {
  //     const response = await fetch(`${appConfig.serverUrl}/api/rooms/${roomId}/participants`);
  //     const data = await response.json();
  //     return data;
  //   } catch (error) {
  //     console.error('Error fetching participants:', error);
  //     return {
  //       success: false,
  //       error: 'Failed to fetch participants.',
  //     };
  //   }
  // }
}

// Export a singleton instance
export const roomService = new RoomService();
